import moment from "moment";
export function display_date(value, strFormat) {
  return value ? moment.parseZone(value).format(strFormat ? strFormat : 'DD-MM-YYYY HH:mm:ss') : '';
  if(!value) return '';
  if(typeof value === 'string' || value instanceof String) {
    value = !value.includes('Z') ? value + 'Z' : value;
  }
  return moment(value).local().format(strFormat ? strFormat : 'DD-MM-YYYY HH:mm:ss');
}

export function display_date_tz(value, strFormat) {
  if(value && !value.includes('.000Z')) {
    value = value + '.000Z';
  }
  return value ? moment(value).format(strFormat ? strFormat : 'DD-MM-YYYY HH:mm:ss') : '';
}

export function capitalize(value){
  return value.toLowerCase().replace(/^.|\s\S/g, function(a) { return a.toUpperCase(); });
};

export function display_value(value, enums, key_name = 'value', val_name = 'name') {
  if(!enums) {
    return '';
  }
  const item = enums.find(obj => obj[key_name] === value);
  return item && item[val_name] ? item[val_name] : '';
}

export function display_color(value, enums) {
  if(!enums) {
    return '';
  }
  const item = enums.find(obj => obj.value === value);
  return item ? item.color : '';
}

export function display_text_color(value, enums) {
  if(!enums) {
    return '';
  }
  const item = enums.find(obj => obj.value === value);
  return item ? item.textColor : '';
}